<template>
  <a-layout class="investment">
    <a-layout-header>
      <PageNav></PageNav>
    </a-layout-header>
    <a-layout-content>
      <div class="investment-content">
        <!--  banner    -->
        <div class="i-banner-wrap flex">
          <div class="i-banner-con flex">
            <div class="c-left flex flex-column align-start jus-center">
              <p class="color-black">{{ $t('investment.overview') }}</p>
              <p class="color-black">{{ $t('investment.overview_desc') }}</p>
            </div>
            <div class="c-right">
              <!-- 未登录状态 -->
              <div class="not-log" v-if="!isLogin">
                <svg width="50" height="50" viewBox="0 0 66 56" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M52.962 3.83c3.23 4.245 2.435 10.285-1.776 13.49-4.212 3.204-10.245 2.36-13.475-1.886-3.23-4.245-2.435-10.285 1.776-13.49C43.7-1.26 49.732-.415 52.962 3.83Z"
                      fill="#9C69FF"></path>
                  <path
                      d="M23.228 29.47c-4.163-5.471-3.138-13.254 2.29-17.383 5.426-4.13 13.2-3.042 17.363 2.429 4.163 5.47 3.138 13.253-2.29 17.382-5.426 4.13-13.2 3.042-17.363-2.428Z"
                      fill="#05C3DD"></path>
                  <g filter="url(#assetLogin_svg__a)">
                    <rect x="9" y="22" width="47" height="33" rx="1.82" fill="url(#assetLogin_svg__b)"
                          fill-opacity="0.5"></rect>
                    <rect x="8.75" y="21.75" width="47.5" height="33.5" rx="2.07" stroke="#393939"
                          stroke-width="0.5"></rect>
                  </g>
                  <path fill="#05C3DD" d="M47.233 35.597H58v6.63H47.233z"></path>
                  <defs>
                    <linearGradient id="assetLogin_svg__b" x1="10.152" y1="32.033" x2="15.541" y2="7.514"
                                    gradientUnits="userSpaceOnUse">
                      <stop stop-color="#B8B8B8"></stop>
                      <stop offset="1" stop-color="#393939" stop-opacity="0"></stop>
                    </linearGradient>
                    <filter id="assetLogin_svg__a" x="0.191" y="13.191" width="64.618" height="50.618"
                            filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood>
                      <feGaussianBlur in="BackgroundImageFix" stdDeviation="4.154"></feGaussianBlur>
                      <feComposite in2="SourceAlpha" operator="in"
                                   result="effect1_backgroundBlur_2497_16220"></feComposite>
                      <feBlend in="SourceGraphic" in2="effect1_backgroundBlur_2497_16220" result="shape"></feBlend>
                    </filter>
                  </defs>
                </svg>
                <p>{{ $t('investment.login_to_view_earnings') }}</p>
                <a-button class="button" @click="goToLogin">{{ $t('investment.login') }}</a-button>
              </div>
              <!-- 已登录状态 -->
              <div class="r-main" v-else>
                <div class="login-info">
                  <p class="welcome-text">{{ $t('investment.welcome_back') }}{{ userNickname || $t('investment.user') }}</p>
                  <p class="investment-tip">{{ $t('investment.start_investment_journey') }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--   menu-list  -->
        <div class="i-list-wrap flex align-center jus-center">
          <div class="i-list-con">
            <div class="c-cell flex align-start jus-bet pointer" v-for="(item,index) in list" :key="index">
              <img :src="require('@/assets/images/investment/fundImg' + item.index + '.png')">
              <div class="cell-right flex flex-column align-start">
                <div class="flex align-center">
                  <span class="_title">{{ item.title }}</span>
                  <a-tag class="tag">{{ item.tag }}</a-tag>
                </div>
                <span class="_context">{{ item.context }}</span>
                <a-button class="button" @click="routerlink(item)">{{ $t('investment.go_to_product_list') }}</a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer></Footer>
    </a-layout-footer>
  </a-layout>
</template>
<script>
import PageNav from "@/components/PageNav/PageNav.vue";
import Footer from "@/components/Footer/footer.vue";
import notlog from "@/components/notlog/notlog.vue";
import { mapGetters } from 'vuex';

export default {
  components: {notlog, Footer, PageNav},
  data() {
    return {
      list: [
        // XAU Pledge is temporarily unavailable. Keep the /term route for existing links.
        // {
        //   index: 1,
        //   title: this.$t('investment.wealth_product'),
        //   tag: this.$t('investment.capital_preserved'),
        //   href: "/term",
        //   context: this.$t('investment.wealth_product_desc')
        // },
        {
        index: 2,
        title: this.$t('investment.live_coin_treasure'),
        tag: this.$t('investment.deposit_withdraw_freely'),
        href: "/easyEarn",
        context: this.$t('investment.live_coin_treasure_desc')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['isLogin', 'userNickname'])
  },
  methods: {
    routerlink(item) {
      this.$router.push(item.href)
    },
    // 跳转到登录页面
    goToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./investment.scss";
</style>
